var Config = {
	debug_mode : true,

	isTouchDevice:function(){
		return typeof window.ontouchstart !== 'undefined';
	}

}